import * as React from 'react';
import {connect} from 'react-redux';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {SavedFilters} from 'nutshell-core/saved-filters';
import type {SavedFilter, SavedReportType} from 'nutshell-core/types';

import type {NutshellState} from '../../store';

import {AnalyticsStatusButton} from '../email-marketing/analytics/report/analytics-status/analytics-status-button';
import {ChatHeaderButtons} from '../inbox/chat/chat-header-buttons';
import {PageTitleBar} from '../layout';

import {ReportActionButton} from './report-action-button';
import {getReportTitle, getReportDescription} from './report-constants';
import {shouldShowReportDownloadAndSave} from './report-helpers';
import {ReportTitleBarSaveControls} from './report-title-bar-save-controls';
import type {ReportKey, ReportURLParams} from './report-types';
import {isReportDirty} from './report-utils';
import {SavedReportsModal} from './saved-reports-modal';
import {SchedulerTitleBarButton} from './scheduler/scheduler-title-bar-button';

type OwnProps = {
    reportKey: ReportKey;
    urlParams: ReportURLParams<'leads'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    hasSaveControls?: boolean;
    hasActionButton: boolean;
};
type StateProps = {
    savedReport: SavedFilter<SavedReportType> | null | undefined;
};
type Props = OwnProps & StateProps;

type State = {
    isMyReportsModalOpen: boolean;
};

function mapStateToProps(state: NutshellState, ownProps: OwnProps): StateProps {
    const reportId = ownProps.urlParams.report ? ownProps.urlParams.report.id : undefined;

    return {
        savedReport: reportId ? SavedFilters.getSavedReports(state)[reportId] : undefined,
    };
}

class ReportTitleBarComponent extends React.PureComponent<Props, State> {
    // @ts-expect-error
    saveAnchor: HTMLElement;
    // @ts-expect-error
    saveAsAnchor: HTMLElement;
    // @ts-expect-error
    shareAnchor: HTMLElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            isMyReportsModalOpen: false,
        };
    }

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    render() {
        const canResaveReport = isReportDirty(
            this.props.reportKey,
            this.props.urlParams,
            this.props.savedReport
        );
        const shouldShowChatHeaderButtons =
            (this.props.reportKey === 'engagement' && NutClientConfig.hasEngagementReportFF) ||
            (this.props.reportKey === 'chatbot' && NutClientConfig.hasChatbotReportFF);
        const shouldShowSchedulerHeaderButton = this.props.reportKey === 'schedulerReport';

        return (
            <PageTitleBar
                title={
                    this.props.savedReport
                        ? this.props.savedReport.name
                        : getReportTitle(this.props.reportKey)
                }
                subheaderPrimaryText={getReportDescription(this.props.reportKey)}
                subheaderSecondaryText={
                    this.props.savedReport ? getReportTitle(this.props.reportKey) : undefined
                }
                buttons={
                    <>
                        {this.props.reportKey === 'attribution' && (
                            <AnalyticsStatusButton pageType='lead-attribution' />
                        )}
                        {shouldShowChatHeaderButtons && <ChatHeaderButtons />}
                        {shouldShowSchedulerHeaderButton && <SchedulerTitleBarButton />}
                        {shouldShowReportDownloadAndSave(this.props.reportKey) && (
                            <>
                                {this.props.hasActionButton && (
                                    <ReportActionButton
                                        urlParams={this.props.urlParams}
                                        reportKey={this.props.reportKey}
                                    />
                                )}
                                <ReportTitleBarSaveControls
                                    savedFilterHumanReadableType='report'
                                    reportKey={this.props.reportKey}
                                    urlParams={this.props.urlParams}
                                    onParamChange={this.props.onParamChange}
                                    onSavedFiltersButtonClick={this.handleMyReportsButtonClick}
                                    hasSaveControls={this.props.hasSaveControls}
                                    canResave={canResaveReport}
                                    parentType='reports'
                                />
                            </>
                        )}

                        <SavedReportsModal
                            isOpen={this.state.isMyReportsModalOpen}
                            onClose={this.handleMyReportsModalClose}
                        />
                    </>
                }
            />
        );
    }

    handleMyReportsButtonClick = () => {
        this.setState({isMyReportsModalOpen: true});
    };

    handleMyReportsModalClose = () => {
        this.setState({isMyReportsModalOpen: false});
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);

export const ReportTitleBar = connector(ReportTitleBarComponent);
